module.exports = __webpack_public_path__ + "7f7e3a4f7656032858897996098b0f69.fbx";